import { forwardRef } from "react";

import { usePopoverLegacyContext } from "./usePopoverLegacyContext";
import { Button, ButtonProps } from "../Button";

export type PopoverLegacyCloseProps = ButtonProps;
export const PopoverLegacyClose = forwardRef<
  HTMLButtonElement,
  PopoverLegacyCloseProps
>(function PopoverClose(props, ref) {
  const { setOpen, onClose } = usePopoverLegacyContext();
  return (
    <Button
      ref={ref}
      data-anv="popover-close"
      {...props}
      onClick={(event) => {
        props.onClick?.(event);
        onClose?.();
        setOpen(false);
      }}
    />
  );
});
